import { getInitialState, MainPropState } from './helper/reducer/getInitialState'
import { onStart } from './helper/reducer/onStart'

export const reducer = (state = getInitialState() as MainPropState, message): MainPropState => {
    if (!message) return state

    switch (message?.type) {
        case 'start':
            const info = onStart(state.info, message.events, message.layer)
            return {
                ...state,
                info
            }
        case 'event':
            return {
                ...state,
                events: {
                    ...state.events,
                    [message?.layer]: message.events
                }
            }
        default:
            return state
    }
}
